import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_V_L, } from '@nu-art/thunderstorm-frontend/index';
import './PathwaysByContextRules.scss';
import { ModuleFE_Pathway } from '@app/pathway-frontend';
import { arrayIncludesAny, asArray, dbObjectToId } from '@nu-art/ts-common';
import { getSelectedContextRulesIds } from './utils.js';
import { getMatchingPathwaysByContextRules } from '../utils.js';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
export class PathwaysByContextRules extends TS_EditableItemComponentProto {
    __onPathwayUpdated(...params) {
        this.forceUpdate();
    }
    ;
    __onContextRulesUpdated(...params) {
        if (arrayIncludesAny(asArray(params[1]).map(dbObjectToId), this.props.editable.item.contextRuleIds ?? []))
            this.forceUpdate();
    }
    ;
    // ######################## Render ########################
    renderContextRuleTitle = (label) => {
        return _jsx("div", { className: 'grid_data__context_rule__title', children: label });
    };
    renderContextRules = () => {
        const contextRuleIds = this.props.editable.item.contextRuleIds;
        const selectedContextRules = getSelectedContextRulesIds(contextRuleIds);
        return (_jsx(LL_V_L, { children: selectedContextRules?.map(contextRule => (_jsx("div", { className: "grid-data", children: this.renderContextRuleTitle(contextRule.label) }, contextRule._id))) }));
    };
    renderContextRulesWithPathways = () => {
        const contextRuleIds = this.props.editable.item.contextRuleIds;
        const selectedContextRules = getSelectedContextRulesIds(contextRuleIds);
        const pathways = ModuleFE_Pathway.getNonArchivedPathways();
        const matchingMap = getMatchingPathwaysByContextRules(pathways, selectedContextRules);
        return (_jsx(LL_V_L, { children: selectedContextRules?.map(contextRule => (_jsxs("div", { className: "grid-data", children: [this.renderContextRuleTitle(contextRule.label), _jsx(LL_V_L, { className: 'grid_data__context_rule__pathway', children: matchingMap[contextRule._id]?.length > 0 ? (matchingMap[contextRule._id].map(pathway => (_jsx(LL_V_L, { children: pathway.label }, pathway._id)))) : (_jsx(LL_V_L, { children: "No matching pathways" })) })] }, contextRule._id))) }));
    };
    render() {
        return this.props.showPathways ? this.renderContextRulesWithPathways() : this.renderContextRules();
    }
}
//# sourceMappingURL=PathwaysByContextRules.js.map